import React, { useEffect, useState } from "react";
import useEmails from "./AlertEmails";
import { PencilSquare, Trash } from "react-bootstrap-icons";
import { PulseLoader } from "react-spinners";
import ConfirmDeleteDialog from "../../../../components/Dialog/Dialog";
import { IEmail } from "../../../../interfaces/IEmailAlerts";
import "./AlertEmailsList.css";

interface AlertEmailsListProps {
  onEdit: (email: IEmail) => void;
}

const AlertEmailsList: React.FC<AlertEmailsListProps> = ({ onEdit }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [emailToDelete, setEmailToDelete] = useState<IEmail | undefined>();

  const { emails, isLoading, isError, deleteEmail } = useEmails();

  const onDelete = (email: IEmail) => {
    setEmailToDelete(email);
    setDialogOpen(true);
    setDialogMessage(
      `Are you sure you want to delete ${email.Files.map(fileDict => Object.values(fileDict).join(", ")).join(", ")} associated with ${email.Address}?`
    );    
  };

  const onConfirmDelete = () => {
    setDialogOpen(false);
    deleteEmail(emailToDelete!);
    setEmailToDelete(undefined);
  };

  return (
    <>
      <ConfirmDeleteDialog
        isOpen={dialogOpen}
        title="Confirm delete"
        message={dialogMessage}
        primaryText="Delete"
        secondaryText="Cancel"
        onPrimary={onConfirmDelete}
        onSecondary={() => setDialogOpen(false)}
      />
      <div className="container-fluid mt-2">
        {isError ? (
          <div className="d-flex justify-content-center">
            Something went wrong, please try again
          </div>
        ) : isLoading ? (
          <div className="d-flex justify-content-center">
            <PulseLoader />
          </div>
        ) : emails.length === 0 ? (
          <div className="d-flex justify-content-center">
            No emails have been configured
          </div>
        ) : (
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Email Address</th>
                <th className="text-center" scope="col">Task</th>
                <th className="text-center" scope="col">Files</th>
                <th className="text-center" scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {emails.map((email, index) => (
                <tr key={index}>
                  <td>{email.Address}</td>
                  <td className="text-center">{email.Task}</td>
                  <td className="text-center">
                    {email.Files
                      .map((fileDict) =>
                        // Extract values from each file dictionary and join them with a comma
                        Object.values(fileDict).join(", ")
                      )
                      .join(", ")} 
                  </td>
                  <td className="text-center">
                    <PencilSquare
                      role="button"
                      color="blue"
                      className="me-2"
                      onClick={() => onEdit(email)}
                    />
                    <Trash
                      role="button"
                      color="red"
                      onClick={() => onDelete(email)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default AlertEmailsList;
